export enum TimelineTypeEnum {
    BASIC = "BASIC",
    FULL = "FULL",
  
  }